const secondStepData = {
    fatherName: '',
    motherName: '',
    phone: '',
    phone1: '',
    email: '',
    email1:'',
    fatherLang:'',
    motherLang:'',
    resadd:'',
    resadd1:'',
    area:'',
    area1:'',
    dist:'',
    dist1:'',
    state:'',
    state1:'',
    country:'',
    country1:'',
    pin:'',
    pin1:'',
    offnum:'',
    offnum1:'',
    resnum:'',
    resnum1:'',
    gross:'',
    gross1:'',
    working: false,
    working1: false,
    designation: '',
    designation1:'',
    company:'',
    company1:'',
    companyAdd:'',
    companyAdd1:'',
    address: false,
    compPhoto: null,
    compPhoto1: null,
    fileName:'',
    fileName1:'',
    imagePreviewUrl:'',
    imagePreviewUrl1:'',
  };


  export default secondStepData;
  